import React from 'react';
import { BookOpen, Users, FileText, MessageSquare, Megaphone, Bell, Ban, Shield, UserX, Edit, Trash2, Info } from 'lucide-react';

export const AdminHowTo = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl p-8 shadow-sm border border-slate-200">
        <div className="flex items-center mb-6">
          <BookOpen className="h-8 w-8 text-[#8B1818] mr-3" />
          <h2 className="text-2xl font-bold text-slate-900">Admin Guide</h2>
        </div>
        <p className="text-slate-600 mb-8">Welcome to the LexDoRight Admin Dashboard. This guide will help you manage your platform effectively.</p>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
            <Users className="h-5 w-5 text-[#8B1818] mr-2" />
            User Management
          </h3>
          <div className="bg-slate-50 rounded-lg p-6 space-y-4">
            <div><h4 className="font-semibold text-slate-900">View Users</h4><p className="text-slate-600 text-sm">Go to the "Users" tab to see all registered users, their email, role, and status.</p></div>
            <div><h4 className="font-semibold text-slate-900">Send Notifications</h4><p className="text-slate-600 text-sm">Click the <Bell className="h-4 w-4 inline text-blue-600" /> bell icon next to a user to send them a notification.</p></div>
            <div><h4 className="font-semibold text-slate-900">Ban/Unban Users</h4><p className="text-slate-600 text-sm">Click the <Ban className="h-4 w-4 inline text-yellow-600" /> ban icon to ban a user. Click again to unban them.</p></div>
            <div><h4 className="font-semibold text-slate-900">Make/Remove Admin</h4><p className="text-slate-600 text-sm">Click the <Shield className="h-4 w-4 inline text-green-600" /> shield icon to promote a user to admin or demote an admin.</p></div>
            <div><h4 className="font-semibold text-slate-900">Delete Users</h4><p className="text-slate-600 text-sm">Click the <UserX className="h-4 w-4 inline text-red-600" /> icon to permanently delete a user.</p></div>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
            <FileText className="h-5 w-5 text-[#8B1818] mr-2" />
            Blog Management
          </h3>
          <div className="bg-slate-50 rounded-lg p-6 space-y-4">
            <div><h4 className="font-semibold text-slate-900">Create Blog Posts</h4><p className="text-slate-600 text-sm">Go to "Blog Posts" tab, fill in the form, then click "Create Post".</p></div>
            <div><h4 className="font-semibold text-slate-900">Edit Blog Posts</h4><p className="text-slate-600 text-sm">Click the <Edit className="h-4 w-4 inline text-blue-600" /> edit icon next to any blog post to modify its content.</p></div>
            <div><h4 className="font-semibold text-slate-900">Delete Blog Posts</h4><p className="text-slate-600 text-sm">Click the <Trash2 className="h-4 w-4 inline text-red-600" /> trash icon to remove a blog post.</p></div>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
            <MessageSquare className="h-5 w-5 text-[#8B1818] mr-2" />
            Forum Management
          </h3>
          <div className="bg-slate-50 rounded-lg p-6 space-y-4">
            <div><h4 className="font-semibold text-slate-900">Edit Forum Topics</h4><p className="text-slate-600 text-sm">Go to "Forum Topics" tab to view and edit all forum posts.</p></div>
            <div><h4 className="font-semibold text-slate-900">Respond to Forum Topics</h4><p className="text-slate-600 text-sm">Visit any forum topic page while logged in as admin for official responses.</p></div>
            <div><h4 className="font-semibold text-slate-900">Post Announcements</h4><p className="text-slate-600 text-sm">Click "Send Announcement" on the Dashboard to create announcements.</p></div>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
            <Megaphone className="h-5 w-5 text-[#8B1818] mr-2" />
            Quick Actions
          </h3>
          <div className="bg-slate-50 rounded-lg p-6 space-y-4">
            <div><h4 className="font-semibold text-slate-900">Send Announcement</h4><p className="text-slate-600 text-sm">From the Dashboard, click "Send Announcement" to post a message.</p></div>
            <div><h4 className="font-semibold text-slate-900">View Statistics</h4><p className="text-slate-600 text-sm">The Dashboard shows key metrics: Total Users, Products, Blog Posts, and Orders.</p></div>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-lg font-bold text-blue-900 mb-3 flex items-center">
            <Info className="h-5 w-5 mr-2" />
            Tips for Admins
          </h3>
          <ul className="space-y-2 text-blue-800 text-sm">
            <li>Always review content before publishing to maintain quality.</li>
            <li>Use the notification system to communicate important updates to users.</li>
            <li>Regularly check the Forum for questions that need official responses.</li>
            <li>Keep blog content relevant to legal, policy, and governance topics.</li>
            <li>Use announcements sparingly for important platform-wide messages.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
